import { AgGridReact } from "ag-grid-react"
import "ag-grid-community/dist/styles/ag-grid.css"
import "ag-grid-community/dist/styles/ag-theme-alpine.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "ag-grid-enterprise"
import { LicenseManager } from "ag-grid-enterprise"
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react"
import { Row, Col, Container, Button, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import {
  fetchRoleListingBySection,
  changeUserRoleStatus,
  updateUserRolePosition,
} from "store/actions"
import ActiveInactive from "./ActiveInactive"
import BtnCellRenderer from "./BtnCellRenderer"

const ListRoles = props => {
  const dispatch = useDispatch()

  let key = `${process.env.REACT_APP_AG_GRID_LICENSE_KEY}`
  LicenseManager.setLicenseKey(key)
  document.title = "User Roles"

  const gridRef = useRef()

  const [rowData, setRowData] = useState([])
  const [rowPositions, setRowPositions] = useState([])

  const columnDefination = [
    {
      field: "action",
      cellRenderer: "BtnCellRenderer",
      maxWidth: 200,
      cellRendererSelector: params => {
        const buttons = {
          component: BtnCellRenderer,
        }
        if (params) return buttons
        else return undefined
      },
    },
    {
      headerName: "Name",
      rowDrag: true,
      field: "user_role_name",
    },
    {
      headerName: "Short",
      field: "user_role_short",
    },
    {
      headerName: "Status",
      field: "status",
      cellRenderer: "ActiveInactive",
      cellRendererSelector: params => {
        const buttons = {
          component: ActiveInactive,
          params: {
            callChangeRoleStatus: callChangeRoleStatus,
          },
        }
        if (params) return buttons
        else return undefined
      },
    },
  ]
  const [columnDefs, setColumnDefs] = useState(columnDefination)

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 200,
      resizable: true,
    }),
    []
  )

  const onGridReady = useCallback(params => {
    // remove previous records
    setRowData([])
    // access the Grid API
    gridRef?.api?.deselectAll()

    gridRef?.current?.api?.setFilterModel(null)
    // access the Grid Column API
    gridRef?.columnApi?.resetColumnState()

    // refresh the grid
    gridRef?.api?.redrawRows()
  }, [])

  const { error, loading, msg, roles, positionUpdate } = useSelector(state => ({
    error: state.Role.error,
    loading: state.Role.loading,
    msg: state.Role.msg,
    roles: state.Role.role,
    positionUpdate: state.Role.positionUpdate,
  }))

  useEffect(() => {
    let roleData = { section: "user_role" }
    dispatch(fetchRoleListingBySection(roleData))
  }, [])

  useEffect(() => {
    if (roles && roles.length > 0) {
      setRowData(roles)
      if (columnDefination && roles && roles.length > 0) {
        gridRef?.current?.api?.setColumnDefs(columnDefination)
      }
    }
  }, [roles])

  const onRowDragEnd = useCallback(e => {
    let allNodes = e.api.getRenderedNodes()
    let updatedNodes = []
    if (Array.isArray(allNodes) && allNodes.length) {
      allNodes.forEach(function (arrayItem) {
        updatedNodes.push({
          id: arrayItem.data.role_id,
          position: arrayItem.rowIndex,
        })
      })
      setRowPositions(updatedNodes)
    }
  }, [])

  function callChangeRoleStatus(id) {
    dispatch(changeUserRoleStatus(id))
  }

  function updatePositions() {
    if (rowPositions.length) {
      // api call
      dispatch(
        updateUserRolePosition({ section: "user_role", nodes: rowPositions })
      )
    }
  }

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    } else if (positionUpdate && msg) {
      toast.dismiss()
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
      setRowPositions([])
    }
  }, [msg, positionUpdate, error])

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container fluid={true}>
          {msg || error ? <ToastContainer /> : ""}
          <Row>
            <Col>
              <h5>User Roles</h5>
            </Col>
            <Col>
              <div className="d-flex justify-content-end">
                <Link
                  className="btn btn-primary mb-2"
                  to="/dropdown/user_role/add"
                >
                  Add
                </Link>
                {rowPositions.length ? (
                  <button
                    className="btn btn-secondary mb-2 mx-1"
                    onClick={updatePositions}
                  >
                    Update Positions
                  </button>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12} xl={12}>
              <div
                className="ag-theme-alpine"
                style={{ width: "100%", height: "80vh" }}
              >
                <AgGridReact
                  ref={gridRef}
                  rowData={rowData}
                  animateRows={true}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowDragManaged={true}
                  onRowDragEnd={onRowDragEnd}
                  enableCellChangeFlash={true}
                  suppressChangeDetection={true}
                  onGridReady={onGridReady}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ListRoles
